import React, { lazy } from 'react'

const RoleListing = lazy(() =>
  import('./RoleListing').then(module => ({
    default: module.RoleListing,
  }))
)
const RoleAccountListing = lazy(() =>
  import('./RoleAccountAssignmentMain').then(module => ({
    default: module.RoleAccountAssignmentMain,
  }))
)
const RoleProductListing = lazy(() =>
  import('./RoleProductAssignmentMain').then(module => ({
    default: module.RoleProductAssignmentMain,
  }))
)

const RoleRoutes = [
  {
    props: { exact: true, path: '/roles' },
    component: <RoleListing />,
  },
  {
    props: { exact: true, path: '/role/account_assignment/:roleID' },
    component: <RoleAccountListing />,
  },
  {
    props: { exact: true, path: '/role/product_assignment/:roleID' },
    component: <RoleProductListing />,
  },
]

export default RoleRoutes
